import { SIGN_UP, SIGN_UP_SUCCESS, SIGN_UP_FAILURE, ENTER_OTP, ENTER_OTP_SUCCESS, ENTER_OTP_FAILURE, RESEND_OTP, RESEND_OTP_SUCCESS, RESEND_OTP_FAILURE, SIGN_IN, SIGN_IN_SUCCESS, SIGN_IN_FAILURE, GET_USER_TYPE, GET_USER_TYPE_SUCCESS, GET_USER_TYPE_FAILURE, GET_STATE, GET_STATE_SUCCESS, GET_STATE_FAILURE, GET_LOCAL_GOVERNMENT_BY_STATE_ID, GET_LOCAL_GOVERNMENT_BY_STATE_ID_SUCCESS, GET_LOCAL_GOVERNMENT_BY_STATE_ID_FAILURE, POST_USER_TYPE, POST_USER_TYPE_SUCCESS, POST_USER_TYPE_FAILURE, POST_BUSINESS_DETAILS, POST_BUSINESS_DETAILS_SUCCESS, POST_BUSINESS_DETAILS_FAILURE, POST_BUSINESS_LOCATION, POST_BUSINESS_LOCATION_SUCCESS, POST_BUSINESS_LOCATION_FAILURE, POST_BUSINESS_HISTORY, POST_BUSINESS_HISTORY_SUCCESS, POST_BUSINESS_HISTORY_FAILURE, POST_BUSINESS_CONTACT, POST_BUSINESS_CONTACT_SUCCESS, POST_BUSINESS_CONTACT_FAILURE, POST_USER_DETAILS, POST_USER_DETAILS_SUCCESS, POST_USER_DETAILS_FAILURE, GET_RELATIONSHIP_TYPE, GET_RELATIONSHIP_TYPE_SUCCESS, GET_RELATIONSHIP_TYPE_FAILURE, FORGOT_PASSWORD, FORGOT_PASSWORD_SUCCESS, FORGOT_PASSWORD_FAILURE, NEW_PASSWORD, NEW_PASSWORD_SUCCESS, NEW_PASSWORD_FAILURE, CHANGE_PASSWORD, CHANGE_PASSWORD_SUCCESS, CHANGE_PASSWORD_FAILURE, GET_ALL_CUSTOMERS, GET_ALL_CUSTOMERS_SUCCESS, GET_ALL_CUSTOMERS_FAILURE, GET_ALL_SYSTEM_ADMIN, GET_ALL_SYSTEM_ADMIN_SUCCESS, GET_ALL_SYSTEM_ADMIN_FAILURE, GET_ALL_INDEPENDENT_DISTRIBUTORSHIP, GET_ALL_INDEPENDENT_DISTRIBUTORSHIP_SUCCESS, GET_ALL_INDEPENDENT_DISTRIBUTORSHIP_FAILURE, GET_INDEPENDENT_DISTRIBUTOR_NEAR_ME, GET_INDEPENDENT_DISTRIBUTOR_NEAR_ME_SUCCESS, GET_INDEPENDENT_DISTRIBUTOR_NEAR_ME_FAILURE, GET_NATURE_OF_BUSINESS, GET_NATURE_OF_BUSINESS_SUCCESS, GET_NATURE_OF_BUSINESS_FAILURE, POST_BUSINESS_DOCUMENT, POST_BUSINESS_DOCUMENT_SUCCESS, POST_BUSINESS_DOCUMENT_FAILURE, GET_BUSINESS_DOCUMENT, GET_BUSINESS_DOCUMENT_SUCCESS, GET_BUSINESS_DOCUMENT_FAILURE, GET_USER_BY_ID, GET_USER_BY_ID_SUCCESS, GET_USER_BY_ID_FAILURE, GET_PENDING_APPLICATION, GET_PENDING_APPLICATION_SUCCESS, GET_PENDING_APPLICATION_FAILURE, GET_APPROVED_APPLICATION, GET_APPROVED_APPLICATION_SUCCESS, GET_APPROVED_APPLICATION_FAILURE, POST_ASSIGNED_DISTRIBUTOR, POST_ASSIGNED_DISTRIBUTOR_SUCCESS, POST_ASSIGNED_DISTRIBUTOR_FAILURE, GET_USER_PROFILE_DETAILS, GET_USER_PROFILE_DETAILS_SUCCESS, GET_USER_PROFILE_DETAILS_FAILURE, POST_BUSINESS_AREA, POST_BUSINESS_AREA_SUCCESS, POST_BUSINESS_AREA_FAILURE, GET_BUSINESS_AREA, GET_BUSINESS_AREA_SUCCESS, GET_BUSINESS_AREA_FAILURE, POST_PROFILE_PICTURE_AVATAR, POST_PROFILE_PICTURE_AVATAR_SUCCESS, POST_PROFILE_PICTURE_AVATAR_FAILURE, GET_ALL_ROLES, GET_ALL_ROLES_SUCCESS, GET_ALL_ROLES_FAILURE, CREATE_EMPLOYEE, CREATE_EMPLOYEE_SUCCESS, CREATE_EMPLOYEE_FAILURE, CREATE_DISTRIBUTOR_CUSTOMER, CREATE_DISTRIBUTOR_CUSTOMER_SUCCESS, CREATE_DISTRIBUTOR_CUSTOMER_FAILURE, CREATE_RETAILER_CUSTOMER, CREATE_RETAILER_CUSTOMER_SUCCESS, CREATE_RETAILER_CUSTOMER_FAILURE, CREATE_EXCLUSIVE_CUSTOMER, CREATE_EXCLUSIVE_CUSTOMER_SUCCESS, CREATE_EXCLUSIVE_CUSTOMER_FAILURE, UPDATE_EMPLOYEE_DETAILS, UPDATE_EMPLOYEE_DETAILS_SUCCESS, UPDATE_EMPLOYEE_DETAILS_FAILURE, RESTORE_EMPLOYEE_DETAILS, GET_EMPLOYEE_DATA, GET_EMPLOYEE_DATA_SUCCESS, GET_EMPLOYEE_DATA_FAILURE, RESTORE_DISTRIBUTOR_CREATION, RESTORE_RETAILER_CREATION, RESTORE_EXCLUSIVE_CREATION, UPDATE_ROLE_SUCCESS, UPDATE_ROLE, UPDATE_ROLE_FAILURE, UPDATE_BUSINESS_DOCUMENT, UPDATE_BUSINESS_DOCUMENT_SUCCESS, UPDATE_BUSINESS_DOCUMENT_FAILURE, UPDATE_BUSINESS_AREA, UPDATE_BUSINESS_AREA_SUCCESS, UPDATE_BUSINESS_AREA_FAILURE, GET_GOOGLE_PLACES, GET_GOOGLE_PLACES_SUCCESS, GET_GOOGLE_PLACES_FAILURE, GOOGLE_SIGN_IN, GOOGLE_SIGN_IN_SUCCESS, GOOGLE_SIGN_IN_FAILURE, GOOGLE_SIGN_UP, GOOGLE_SIGN_UP_SUCCESS, GOOGLE_SIGN_UP_FAILURE, UPDATE_USER_STATUS, UPDATE_USER_STATUS_SUCCESS, UPDATE_USER_STATUS_FAILURE, RESET_USER_STATUS, SIGN_OUT_USER, UPDATE_USER_DATA, UPDATE_USER_DATA_SUCCESS, UPDATE_USER_DATA_FAILURE, UPDATE_BUSINESS_DATA, UPDATE_BUSINESS_DATA_SUCCESS, UPDATE_BUSINESS_DATA_FAILURE, DELETE_USER_ACCOUNT, DELETE_USER_ACCOUNT_SUCCESS, DELETE_USER_ACCOUNT_FAILURE, GET_REJECTED_APPLICATION, GET_REJECTED_APPLICATION_SUCCESS, GET_REJECTED_APPLICATION_FAILURE, REJECT_APPLICATION, REJECT_APPLICATION_SUCCESS, REJECT_APPLICATION_FAILURE, SEARCH_CUSTOMERS, SEARCH_CUSTOMERS_FAILURE, SEARCH_CUSTOMERS_SUCCESS, SEARCH_TRANSACTION_LOGS, SEARCH_TRANSACTION_LOGS_SUCCESS, SEARCH_TRANSACTION_LOGS_FAILURE, SEARCH_ROLES, SEARCH_ROLES_SUCCESS, SEARCH_ROLES_FAILURE, RESET_CUSTOMER_DETAILS, DELETE_APPLICANT_DOCUMENT, DELETE_APPLICANT_DOCUMENT_SUCCESS, DELETE_APPLICANT_DOCUMENT_FAILURE} from "../ActionTypes";

export const getSignup = (payload) => ({
    type: SIGN_UP,
    payload
});
export const getSignupSuccess = (payload) => ({
    type: SIGN_UP_SUCCESS,
    payload
});
// To sign up new user
export const getSignupFailure = (payload) => ({
    type: SIGN_UP_FAILURE,
    payload
});

export const getEnterOtp = (payload) => ({
    type: ENTER_OTP,
    payload
});
export const getEnterOtpSuccess = (payload) => ({
    type: ENTER_OTP_SUCCESS,
    payload
});
// To enter otp
export const getEnterOtpFailure = (payload) => ({
    type: ENTER_OTP_FAILURE,
    payload
});

export const getResendOtp = (payload) => ({
    type: RESEND_OTP,
    payload
});
export const getResendOtpSuccess = (payload) => ({
    type: RESEND_OTP_SUCCESS,
    payload
});
// To rsend otp
export const getResendOtpFailure = (payload) => ({
    type: RESEND_OTP_FAILURE,
    payload
});

export const getSignin = (payload) => ({
    type: SIGN_IN,
    payload
});
export const getSigninSuccess = (payload) => ({
    type: SIGN_IN_SUCCESS,
    payload
});
// To sign in new user
export const getSigninFailure = (payload) => ({
    type: SIGN_IN_FAILURE,
    payload
});

export const getForgotPassword = (payload) => ({
    type: FORGOT_PASSWORD,
    payload
});
export const getForgotPasswordSuccess = (payload) => ({
    type: FORGOT_PASSWORD_SUCCESS,
    payload
});
// To forgot password for new user
export const getForgotPasswordFailure = (payload) => ({
    type: FORGOT_PASSWORD_FAILURE,
    payload
});

export const getNewPassword = (payload) => ({
    type: NEW_PASSWORD,
    payload
});
export const getNewPasswordSuccess = (payload) => ({
    type: NEW_PASSWORD_SUCCESS,
    payload
});
// To setup new password for new user
export const getNewPasswordFailure = (payload) => ({
    type: NEW_PASSWORD_FAILURE,
    payload
});

export const getChangePassword = (payload) => ({
    type: CHANGE_PASSWORD,
    payload
});
export const getChangePasswordSuccess = (payload) => ({
    type: CHANGE_PASSWORD_SUCCESS,
    payload
});
// To setup new password for new user
export const getChangePasswordFailure = (payload) => ({
    type: CHANGE_PASSWORD_FAILURE,
    payload
});

export const getUserType = () => ({
    type: GET_USER_TYPE,
    // payload
});
export const getUserTypeSuccess = (payload) => ({
    type: GET_USER_TYPE_SUCCESS,
    payload
});
// To get user type
export const getUserTypeFailure = () => ({
    type: GET_USER_TYPE_FAILURE,
});

export const getRelationshipType = (payload) => ({
    type: GET_RELATIONSHIP_TYPE,
    payload
});
export const getRelationshipTypeSuccess = (payload) => ({
    type: GET_RELATIONSHIP_TYPE_SUCCESS,
    payload
});
// To get user type
export const getRelationshipTypeFailure = (payload) => ({
    type: GET_RELATIONSHIP_TYPE_FAILURE,
    payload
});

export const getNatureOfBusiness = (payload) => ({
    type: GET_NATURE_OF_BUSINESS,
    payload
});
export const getNatureOfBusinessSuccess = (payload) => ({
    type: GET_NATURE_OF_BUSINESS_SUCCESS,
    payload
});
// To get user type
export const getNatureOfBusinessFailure = (payload) => ({
    type: GET_NATURE_OF_BUSINESS_FAILURE,
    payload
});


export const getState = () => ({
    type: GET_STATE,
    // payload
});
export const getStateSuccess = (payload) => ({
    type: GET_STATE_SUCCESS,
    payload
});
// To get state
export const getStateFailure = () => ({
    type: GET_STATE_FAILURE,
});

export const getLocalGovernmentByStateId = (payload) => ({
    type: GET_LOCAL_GOVERNMENT_BY_STATE_ID,
    payload
});
export const getLocalGovernmentByStateIdSuccess = (payload) => ({
    type: GET_LOCAL_GOVERNMENT_BY_STATE_ID_SUCCESS,
    payload
});
// To get state
export const getLocalGovernmentByStateIdFailure = (payload) => ({
    type: GET_LOCAL_GOVERNMENT_BY_STATE_ID_FAILURE,
});

export const postUserTypeData = (payload) => ({
    type: POST_USER_TYPE,
    payload
});
export const postUserTypeDataSuccess = (payload) => ({
    type: POST_USER_TYPE_SUCCESS,
    payload
});
// To get state
export const postUserTypeDataFailure = (payload) => ({
    type: POST_USER_TYPE_FAILURE,
    payload
});

export const postBusinessDetails = (payload) => ({
    type: POST_BUSINESS_DETAILS,
    payload
});
export const postBusinessDetailsSuccess = (payload) => ({
    type: POST_BUSINESS_DETAILS_SUCCESS,
    payload
});
// To sign up new user
export const postBusinessDetailsFailure = (payload) => ({
    type: POST_BUSINESS_DETAILS_FAILURE,
    payload
});

export const postBusinessLocation = (payload) => ({
    type: POST_BUSINESS_LOCATION,
    payload
});
export const postBusinessLocationSuccess = (payload) => ({
    type: POST_BUSINESS_LOCATION_SUCCESS,
    payload
});
// To sign up new user
export const postBusinessLocationFailure = (payload) => ({
    type: POST_BUSINESS_LOCATION_FAILURE,
    payload
});

export const postBusinessHistory = (payload) => ({
    type: POST_BUSINESS_HISTORY,
    payload
});
export const postBusinessHistorySuccess = (payload) => ({
    type: POST_BUSINESS_HISTORY_SUCCESS,
    payload
});
// To sign up new user
export const postBusinessHistoryFailure = (payload) => ({
    type: POST_BUSINESS_HISTORY_FAILURE,
    payload
});

export const postBusinessContact = (payload) => ({
    type: POST_BUSINESS_CONTACT,
    payload
});
export const postBusinessContactSuccess = (payload) => ({
    type: POST_BUSINESS_CONTACT_SUCCESS,
    payload
});
// To sign up new user
export const postBusinessContactFailure = (payload) => ({
    type: POST_BUSINESS_CONTACT_FAILURE,
    payload
});

export const postUserDetails = (payload) => ({
    type: POST_USER_DETAILS,
    payload
});
export const postUserDetailsSuccess = (payload) => ({
    type: POST_USER_DETAILS_SUCCESS,
    payload
});
// To sign up new user
export const postUserDetailsFailure = (payload) => ({
    type: POST_USER_DETAILS_FAILURE,
    payload
});

export const postBusinessDocument = (payload) => ({
    type: POST_BUSINESS_DOCUMENT,
    payload
});
export const postBusinessDocumentSuccess = (payload) => ({
    type: POST_BUSINESS_DOCUMENT_SUCCESS,
    payload
});
// To complete compliance for independent distributor
export const postBusinessDocumentFailure = (payload) => ({
    type: POST_BUSINESS_DOCUMENT_FAILURE,
    payload
});

export const updateBusinessDocument = (body, payload) => ({
    type: UPDATE_BUSINESS_DOCUMENT,
    body,
    payload
});
export const updateBusinessDocumentSuccess = (body, payload) => ({
    type: UPDATE_BUSINESS_DOCUMENT_SUCCESS,
    body,
    payload
});
// To complete compliance for independent distributor
export const updateBusinessDocumentFailure = (body, payload) => ({
    type: UPDATE_BUSINESS_DOCUMENT_FAILURE,
    body,
    payload
});

export const getBusinessDocument = (payload) => ({
    type: GET_BUSINESS_DOCUMENT,
    payload
});
export const getBusinessDocumentSuccess = (payload) => ({
    type: GET_BUSINESS_DOCUMENT_SUCCESS,
    payload
});
// To complete compliance for independent distributor
export const getBusinessDocumentFailure = (payload) => ({
    type: GET_BUSINESS_DOCUMENT_FAILURE,
    payload
});

export const postBusinessArea = (payload) => ({
    type: POST_BUSINESS_AREA,
    payload
});
export const postBusinessAreaSuccess = (payload) => ({
    type: POST_BUSINESS_AREA_SUCCESS,
    payload
});
// To complete compliance for independent distributor
export const postBusinessAreaFailure = (payload) => ({
    type: POST_BUSINESS_AREA_FAILURE,
    payload
});

export const updateBusinessArea = (payload) => ({
    type: UPDATE_BUSINESS_AREA,
    payload
});
export const updateBusinessAreaSuccess = (payload) => ({
    type: UPDATE_BUSINESS_AREA_SUCCESS,
    payload
});
// To complete compliance for independent distributor
export const updateBusinessAreaFailure = (payload) => ({
    type: UPDATE_BUSINESS_AREA_FAILURE,
    payload
});

export const getBusinessArea = (payload) => ({
    type: GET_BUSINESS_AREA,
    payload
});
export const getBusinessAreaSuccess = (payload) => ({
    type: GET_BUSINESS_AREA_SUCCESS,
    payload
});
// To complete compliance for independent distributor
export const getBusinessAreaFailure = (payload) => ({
    type: GET_BUSINESS_AREA_FAILURE,
    payload
});

export const getAllCustomer = (payload) => ({
    type: GET_ALL_CUSTOMERS,
    payload
});
export const getAllCustomerSuccess = (payload) => ({
    type: GET_ALL_CUSTOMERS_SUCCESS,
    payload
});
// To get user type
export const getAllCustomerFailure = (payload) => ({
    type: GET_ALL_CUSTOMERS_FAILURE,
    payload
});

export const getAllSystemAdmin = (payload) => ({
    type: GET_ALL_SYSTEM_ADMIN,
    payload
});
export const getAllSystemAdminSuccess = (payload) => ({
    type: GET_ALL_SYSTEM_ADMIN_SUCCESS,
    payload
});
// To get user type
export const getAllSystemAdminFailure = (payload) => ({
    type: GET_ALL_SYSTEM_ADMIN_FAILURE,
    payload
});

export const getAllIndependentDistributorship = (payload) => ({
    type: GET_ALL_INDEPENDENT_DISTRIBUTORSHIP,
    payload
});
export const getAllIndependentDistributorshipSuccess = (payload) => ({
    type: GET_ALL_INDEPENDENT_DISTRIBUTORSHIP_SUCCESS,
    payload
});
// To get user type
export const getAllIndependentDistributorshipFailure = (payload) => ({
    type: GET_ALL_INDEPENDENT_DISTRIBUTORSHIP_FAILURE,
    payload
});

export const getIndependentDistributorNearMe = (payload) => ({
    type: GET_INDEPENDENT_DISTRIBUTOR_NEAR_ME,
    payload
});
export const getIndependentDistributorNearMeSuccess = (payload) => ({
    type: GET_INDEPENDENT_DISTRIBUTOR_NEAR_ME_SUCCESS,
    payload
});
// To get user type
export const getIndependentDistributorNearMeFailure = (payload) => ({
    type: GET_INDEPENDENT_DISTRIBUTOR_NEAR_ME_FAILURE,
    payload
});

export const getUserById = (body, payload) => ({
    type: GET_USER_BY_ID,
    body,
    payload
});
export const getUserByIdSuccess = (body, payload) => ({
    type: GET_USER_BY_ID_SUCCESS,
    body, 
    payload
});
// To get user type
export const getUserByIdFailure = (body, payload) => ({
    type: GET_USER_BY_ID_FAILURE,
    body, 
    payload
});

export const getPendingApplication = (payload) => ({
    type: GET_PENDING_APPLICATION,
    payload
});
export const getPendingApplicationSuccess = (payload) => ({
    type: GET_PENDING_APPLICATION_SUCCESS,
    payload
});
// To get user type
export const getPendingApplicationFailure = (payload) => ({
    type: GET_PENDING_APPLICATION_FAILURE,
    payload
});

export const getApprovedApplication = (payload) => ({
    type: GET_APPROVED_APPLICATION,
    payload
});
export const getApprovedApplicationSuccess = (payload) => ({
    type: GET_APPROVED_APPLICATION_SUCCESS,
    payload
});
// To get user type
export const getApprovedApplicationFailure = (payload) => ({
    type: GET_APPROVED_APPLICATION_FAILURE,
    payload
});

export const postAssignedDistributor = (payload) => ({
    type: POST_ASSIGNED_DISTRIBUTOR,
    payload
});
export const postAssignedDistributorSuccess = (payload) => ({
    type: POST_ASSIGNED_DISTRIBUTOR_SUCCESS,
    payload
});
// To sign up new user
export const postAssignedDistributorFailure = (payload) => ({
    type: POST_ASSIGNED_DISTRIBUTOR_FAILURE,
    payload
});

export const getUserProfileDetails = (payload) => ({
    type: GET_USER_PROFILE_DETAILS,
    payload
});
export const getUserProfileDetailsSuccess = (payload) => ({
    type: GET_USER_PROFILE_DETAILS_SUCCESS,
    payload
});
// To get user type
export const getUserProfileDetailsFailure = (payload) => ({
    type: GET_USER_PROFILE_DETAILS_FAILURE,
    payload
});

export const postProfilePictureAvatar = (payload) => ({
    type: POST_PROFILE_PICTURE_AVATAR,
    payload
});
export const postProfilePictureAvatarSuccess = (payload) => ({
    type: POST_PROFILE_PICTURE_AVATAR_SUCCESS,
    payload
});
// To sign up new user
export const postProfilePictureAvatarFailure = (payload) => ({
    type: POST_PROFILE_PICTURE_AVATAR_FAILURE,
    payload
});

export const getAllRoles = (payload) => ({
    type: GET_ALL_ROLES,
    payload
});
export const getAllRolesSuccess = (payload) => ({
    type: GET_ALL_ROLES_SUCCESS,
    payload
});
// To get user type
export const getAllRolesFailure = (payload) => ({
    type: GET_ALL_ROLES_FAILURE,
    payload
});

export const postCreateEmployee = (payload) => ({
    type: CREATE_EMPLOYEE,
    payload
});
export const postCreateEmployeeSuccess = (payload) => ({
    type: CREATE_EMPLOYEE_SUCCESS,
    payload
});
// To sign up new user
export const postCreateEmployeeFailure = (payload) => ({
    type: CREATE_EMPLOYEE_FAILURE,
    payload
});

export const postCreateDistributorCustomer = (payload) => ({
    type: CREATE_DISTRIBUTOR_CUSTOMER,
    payload
});
export const postCreateDistributorCustomerSuccess = (payload) => ({
    type: CREATE_DISTRIBUTOR_CUSTOMER_SUCCESS,
    payload
});
// To sign up new user
export const postCreateDistributorCustomerFailure = (payload) => ({
    type: CREATE_DISTRIBUTOR_CUSTOMER_FAILURE,
    payload
});

export const postCreateRetailerCustomer = (payload) => ({
    type: CREATE_RETAILER_CUSTOMER,
    payload
});
export const postCreateRetailerCustomerSuccess = (payload) => ({
    type: CREATE_RETAILER_CUSTOMER_SUCCESS,
    payload
});
// To sign up new user
export const postCreateRetailerCustomerFailure = (payload) => ({
    type: CREATE_RETAILER_CUSTOMER_FAILURE,
    payload
});

export const postCreateExclusiveCustomer = (payload) => ({
    type: CREATE_EXCLUSIVE_CUSTOMER,
    payload
});
export const postCreateExclusiveCustomerSuccess = (payload) => ({
    type: CREATE_EXCLUSIVE_CUSTOMER_SUCCESS,
    payload
});
// To sign up new user
export const postCreateExclusiveCustomerFailure = (payload) => ({
    type: CREATE_EXCLUSIVE_CUSTOMER_FAILURE,
    payload
});

//to update Employee
export const updateEmployeeDetails = (payload) => ({
    type: UPDATE_EMPLOYEE_DETAILS,
    payload
});
export const updateEmployeeDetailsSuccess = (payload) => ({
    type: UPDATE_EMPLOYEE_DETAILS_SUCCESS,
    payload
});
export const updateEmployeeDetailsFailure = (payload) => ({
    type: UPDATE_EMPLOYEE_DETAILS_FAILURE,
    payload
});
export const restoreEmployeeDetails = () => ({
    type: RESTORE_EMPLOYEE_DETAILS,
    
});

export const getEmployeeUnpaginatedData = (payload) => ({
    type: GET_EMPLOYEE_DATA,
    payload
});
export const getEmployeeUnpaginatedDataSuccess = (payload) => ({
    type: GET_EMPLOYEE_DATA_SUCCESS,
    payload
});
// To get state
export const getEmployeeUnpaginatedDataFailure = (payload) => ({
    type: GET_EMPLOYEE_DATA_FAILURE,
    payload
});

export const restoreDistributorCreation = () => ({
    type: RESTORE_DISTRIBUTOR_CREATION,
});
export const restoreRetailerCreation = () => ({
    type: RESTORE_RETAILER_CREATION,
});
export const restoreExclusiveCreation = () => ({
    type: RESTORE_EXCLUSIVE_CREATION,
});

export const updateRoleDetails = (payload) => ({
    type: UPDATE_ROLE,
    payload
});
export const updateRoleDetailsSuccess = (payload) => ({
    type: UPDATE_ROLE_SUCCESS,
    payload
});
export const updateRoleDetailsFailure = (payload) => ({
    type: UPDATE_ROLE_FAILURE,
    payload
});

export const getGooglePlaces = (payload) => ({
    type: GET_GOOGLE_PLACES,
    payload
});
export const getGooglePlacesSuccess = (payload) => ({
    type: GET_GOOGLE_PLACES_SUCCESS,
    payload
});
// To get user type
export const getGooglePlacesFailure = (payload) => ({
    type: GET_GOOGLE_PLACES_FAILURE,
    payload
});
export const googleSignIn = (payload) => ({
    type: GOOGLE_SIGN_IN,
    payload
});
export const googleSignInSuccess = (payload) => ({
    type: GOOGLE_SIGN_IN_SUCCESS,
    payload
});
// To get user type
export const googleSignInFailure = (payload) => ({
    type: GOOGLE_SIGN_IN_FAILURE,
    payload
});
export const googleSignUp = (payload) => ({
    type: GOOGLE_SIGN_UP,
    payload
});
export const googleSignUpSuccess = (payload) => ({
    type: GOOGLE_SIGN_UP_SUCCESS,
    payload
});
// To get user type
export const googleSignUpFailure = (payload) => ({
    type: GOOGLE_SIGN_UP_FAILURE,
    payload
});

export const updateUserStatus = (payload) => ({
    type: UPDATE_USER_STATUS,
    payload
});
export const updateUserStatusSuccess = (payload) => ({
    type: UPDATE_USER_STATUS_SUCCESS,
    payload
});
// To get user type
export const updateUserStatusFailure = (payload) => ({
    type: UPDATE_USER_STATUS_FAILURE,
    payload
});
export const resetUserStatus = () => ({
    type: RESET_USER_STATUS,
});
export const signOutUser = () => ({
    type: SIGN_OUT_USER,
});


export const updateUserData = (payload) => ({
    type: UPDATE_USER_DATA,
    payload
});
export const updateUserDataSuccess = (payload) => ({
    type: UPDATE_USER_DATA_SUCCESS,
    payload
});
export const updateUserDataFailure = (payload) => ({
    type: UPDATE_USER_DATA_FAILURE,
    payload
});
export const updateBusinessData = (payload) => ({
    type: UPDATE_BUSINESS_DATA,
    payload
});
export const updateBusinessDataSuccess = (payload) => ({
    type: UPDATE_BUSINESS_DATA_SUCCESS,
    payload
});
export const updateBusinessDataFailure = (payload) => ({
    type: UPDATE_BUSINESS_DATA_FAILURE,
    payload
});
export const deleteUserAccount = (payload) => ({
    type: DELETE_USER_ACCOUNT,
    payload
});
export const deleteUserAccountSuccess = (payload) => ({
    type: DELETE_USER_ACCOUNT_SUCCESS,
    payload
});
export const deleteUserAccountFailure = (payload) => ({
    type: DELETE_USER_ACCOUNT_FAILURE,
    payload
});

export const getRejectedApplication = (payload) => ({
    type: GET_REJECTED_APPLICATION,
    payload
});
export const getRejectedApplicationSuccess = (payload) => ({
    type: GET_REJECTED_APPLICATION_SUCCESS,
    payload
});
// To get user type
export const getRejectedApplicationFailure = (payload) => ({
    type: GET_REJECTED_APPLICATION_FAILURE,
    payload
});
export const rejectApplication = (payload) => ({
    type: REJECT_APPLICATION,
    payload
});
export const rejectApplicationSuccess = (payload) => ({
    type: REJECT_APPLICATION_SUCCESS,
    payload
});
// To get user type
export const rejectApplicationFailure = (payload) => ({
    type: REJECT_APPLICATION_FAILURE,
    payload
});

export const searchCustomers = (payload)=>({
    type:SEARCH_CUSTOMERS,
    payload
});
export const searchCustomersSuccess = (payload)=>({
    type:SEARCH_CUSTOMERS_SUCCESS,
    payload
});
export const searchCustomersFailure = (payload)=>({
    type:SEARCH_CUSTOMERS_FAILURE,
    payload
});
export const searchTransactionLogs = (payload)=>({
    type:SEARCH_TRANSACTION_LOGS,
    payload
});
export const searchTransactionLogsSuccess = (payload)=>({
    type:SEARCH_TRANSACTION_LOGS_SUCCESS,
    payload
});
export const searchTransactionLogsFailure = (payload)=>({
    type:SEARCH_TRANSACTION_LOGS_FAILURE,
    payload
});

export const searchRoles = (payload)=>({
    type:SEARCH_ROLES,
    payload
});
export const searchRolesSuccess = (payload)=>({
    type:SEARCH_ROLES_SUCCESS,
    payload
});
export const searchRolesFailure = (payload)=>({
    type:SEARCH_ROLES_FAILURE,
    payload
});

export const resetCustomerDetails = ()=>({
    type:RESET_CUSTOMER_DETAILS,
});

export const deleteApplicantDocument = (payload) => ({
    type: DELETE_APPLICANT_DOCUMENT,
    payload
});
export const deleteApplicantDocumentSuccess = (payload) => ({
    type: DELETE_APPLICANT_DOCUMENT_SUCCESS,
    payload
});
// To delete state
export const deleteApplicantDocumentFailure = (payload) => ({
    type: DELETE_APPLICANT_DOCUMENT_FAILURE,
    payload
});
